import * as React from "react";
import type { SVGProps } from "react";
const SvgMoonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="moon_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M487.595 101.845a42.667 42.667 0 0 1 5.546 42.88A298.667 298.667 0 0 0 873.9 541.1a42.667 42.667 0 0 1 57 48.04C892.843 785.792 719.787 934.315 512 934.315c-235.648 0-426.667-191.062-426.667-426.667 0-213.76 157.099-390.699 362.112-421.845a42.667 42.667 0 0 1 40.15 16.042zm-96.598 86.486a341.333 341.333 0 1 0 435.115 453.034A384 384 0 0 1 391.04 188.331z"
    />
  </svg>
);
export default SvgMoonIcon;
